<template>
    <v-card>
        <v-card-text>
            <v-row justify="center">
                <template
                    v-for="(key, index) in [
                        'Credit',
                        'Income',
                        'Rental References',
                        'Crime',
                        'Evictions',
                    ]"
                >
                    <v-col cols="4" :key="index">
                        <v-card
                            class="
                                pl-0
                                pr-3
                                py-5
                                text-center
                                justify-center
                                align-center
                            "
                            outlined
                            max-width="300"
                            :disabled="isDisabled(key)"
                            :color="isDisabled(key) ? 'grey lighten-3' : ''"
                        >
                            <apex-radial-chart
                                class="mx-auto mt-2"
                                :value="$_.get(ratings, key, '')"
                            ></apex-radial-chart>
                            <h3 class="text-center text-uppercase mt-3">
                                {{ key }}
                            </h3>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    name: "screening-ratings",
    components: {
        ApexRadialChart: () => import("@components/lib/Charts/ApexRadialChart"),
    },
    props: {
        scorecard: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        ratings() {
            return this.scorecard.ratings;
        },
    },
    methods: {
        isDisabled(key) {
            return this.$_.get(this.ratings, key, "N/A") === "N/A";
        },
    },
};
</script>

<style scoped>
</style>